var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeanutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.477,
    height: 69.359,
    viewBox: "0 0 66.477 69.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.754 10.098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.759,59.641a52.575,52.575,0,0,1,4.328,5.77",
    transform: "translate(-0.349 -25.018)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.873,49.6a36.107,36.107,0,0,1,5.771,5.771",
    transform: "translate(3.98 -25.018)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.612,32.23A17.168,17.168,0,0,1,59.5,35.116",
    transform: "translate(-56.612 -25.017)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,25.017a36.107,36.107,0,0,1,5.771,5.771",
    transform: "translate(-45.07 -25.017)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 57.706,
    y2: 57.705,
    transform: "translate(2.885 4.328)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.484,54.55a14.862,14.862,0,0,0-4.74-2.123C50.334,51.414,47.86,51,45.088,48.1a19.724,19.724,0,0,1-5.77-14.427c0-4.525,1.093-9.6,4.328-12.984a19.13,19.13,0,0,1,27.41,0,24.121,24.121,0,0,1,5.771,10.1,23.245,23.245,0,0,0,1.424,4",
    transform: "translate(-39.318 -14.919)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.184,53.87a39.382,39.382,0,0,0-4.769-4.98",
    transform: "translate(0.652 -14.92)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.885 23.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.406,38.321a12.717,12.717,0,0,0,4.648,2.565c3.55,1.168,7.147,2.619,10.1,5.7,4.456,4.659,7.213,9.9,7.213,15.935,0,5.171-1.014,10.765-4.328,14.23C49.1,79.831,44.474,81.279,40.5,81.279a24.056,24.056,0,0,1-17.312-7.213c-2.951-3.086-6.1-9.273-7.213-12.984a20.387,20.387,0,0,0-1.2-3.131",
    transform: "translate(-14.775 -38.321)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeanutIcon);
export default __webpack_public_path__ + "static/media/peanut-icon.cc6c4dea.svg";
export { ForwardRef as ReactComponent };